// extracted by mini-css-extract-plugin
export default {"richTextContent":"RichTextContent_richTextContent__TuAaU"};